/**
 * icon-story-grain.js
 * Generates a single-frame noise texture for hero backgrounds.
 * Applied via CSS custom property as a data-URL background image.
 */
(function() {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function generateGrain() {
    var size = 256;
    var canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    var ctx = canvas.getContext('2d');
    var imageData = ctx.createImageData(size, size);
    var data = imageData.data;

    for (var i = 0; i < data.length; i += 4) {
      var value = Math.random() * 255 | 0;
      data[i] = value;
      data[i + 1] = value;
      data[i + 2] = value;
      data[i + 3] = 18; // Very low alpha for subtlety
    }

    ctx.putImageData(imageData, 0, 0);
    return canvas.toDataURL('image/png');
  }

  function applyGrain() {
    var heroes = document.querySelectorAll('.is-hero');
    if (!heroes.length) return;

    var grainURL = generateGrain();
    heroes.forEach(function(hero) {
      hero.style.setProperty('--grain-texture', 'url(' + grainURL + ')');
      hero.classList.add('is-hero--grain');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyGrain);
  } else {
    applyGrain();
  }
})();
